/**
 * Sözleşmeler domaininin BÖLÜMLERİ (D02).
 *
 * Kanonik bilgi mimarisi D02'nin altında iki sayfa tanımlıyor: Tüm Sözleşmeler ve Şablonlar.
 * Şablonlar sidebar'da Sözleşmeler'in kardeşi DEĞİL; üst düzey öğe olarak eklemek
 * `navigation.ts`'teki kanonik sırayı bozardı. Bu yüzden alt sayfalar kendi kaydında ve
 * `ContractsLayout` tarafından çiziliyor — Organizasyon Yönetimi'ndeki (EP13) çözümün aynısı.
 *
 * Kayıt `organizationSections.ts` ile AYNI kuralları taşıyor: yetkisi olmayan bölüm
 * çizilmez, sıra sabittir. Aynı kuralı iki farklı biçimde yazmak, birinin gün gelip
 * diğerinden ayrışması demekti (kriter 5).
 *
 * ⚠ Görünürlük bir GÜVENLİK SINIRI DEĞİL: gerçek kapı her uçtaki `requirePermission`.
 */

export interface ContractSection {
  key: string;
  label: string;
  route: string;
  /** Gerektiren yetki; `null` ise bölüm herkese açık. */
  permission: string | null;
}

/** ⚠ SIRA KANONİKTİR. Yeni bölüm araya değil, kartının söylediği yere girer. */
export const CONTRACT_SECTIONS: readonly ContractSection[] = [
  {
    key: "list",
    label: "Tüm Sözleşmeler",
    route: "/app/sozlesmeler",
    permission: "contract.view",
  },
  /**
   * ⚠ Kapı `template.view`, `template.create` DEĞİL: şablon kütüphanesini yalnız
   * okuyabilen kullanıcı da listeyi görebilmeli. Oluşturma komutu sayfa içinde ayrıca
   * kapılı (`TemplatesPage`).
   */
  {
    key: "templates",
    label: "Şablonlar",
    route: "/app/sablonlar",
    permission: "template.view",
  },
  /**
   * GELEN SÖZLEŞME DAVETLERİ (CLOS-874).
   *
   * ### ⚠ NEDEN "DAVETLERİM"DE DEĞİL
   *
   * Kartın ilk önerisi bu daveti Davetlerim merkezine dördüncü aile olarak eklemekti.
   * Ölçüldü ve bu davet diğer üçüyle AYNI CİNSTEN DEĞİL:
   *
   * | | Diğer üç aile | `contract_org` |
   * |---|---|---|
   * | muhatap | KİŞİ (e-posta) | **ORGANİZASYON** (`target_tenant_id`) |
   * | RLS | `self_invitation` — oturum sahibi | `target_read` — aktif alan |
   * | okuma bağlamı | `withUser`, tenant'sız | **`withTenant`** |
   * | yetki | yok (kendi davetin) | **`contract.share`** |
   * | yanıtlayan | yalnız davetli | yetkili HER üye |
   *
   * Davetlerim merkezi *"hesap-seviyesi, tenant'sız"* olarak kurulmuş
   * (`lib/invitationInbox.ts`); oraya koymak satırların hiç okunamaması, merkeze
   * alan-başına yetki sorgusu girmesi ve yüzeyin adının yanlış olması demekti — bu
   * davet kullanıcıya değil ORGANİZASYONUNA geliyor.
   *
   * ⚠ Karar bağımsız olarak KANONİK MATRİSTE de yazılı: `routing.ts` bu olayın bildirim
   * dağıtımını *"Hedefin kabul kutusu daveti KENDİ BAĞLAMINDAN okuyor"* gerekçesiyle
   * atlıyor. Yani bu yüzeyin aktif alanda olması yeni bir tasarım değil, kayıtlı kararın
   * uygulanması.
   *
   * ⚠ Kapı `contract.share` — ucun kapısıyla AYNI. Farklı bir anahtar seçseydik menüde
   * görünüp girilince 403 alınan bir kapı doğardı.
   */
  /**
   * PAYLAŞILAN SÖZLEŞMELER — katılımcı organizasyon tarafı (CLOS-873, CLOS-154 `[140]`).
   *
   * ⚠ Bu bölüm "Tüm Sözleşmeler"in bir SÜZGECİ DEĞİL, ayrı bir kaynak. `/api/contracts`
   * yalnız SAHİP olunan kayıtları veriyor; paylaşılan sözleşme sahibin tenant'ında
   * yaşıyor ve `/api/shared-contracts` projeksiyonundan okunuyor. İki listeyi tek
   * sayfada birleştirmek, iki farklı erişim modelini tek tabloya sıkıştırmak olurdu:
   * paylaşılan satırın ne sahibi, ne düzenlenebilir metni, ne de aynı eylemleri var.
   *
   * ⚠ Kapı `contract.view` — ucun kapısıyla AYNI (`sharedContractRoutes.ts`). Menüde
   * görünüp girilince 403 alınan bir kapı doğmasın diye.
   */
  {
    key: "shared",
    label: "Paylaşılanlar",
    route: "/app/sozlesmeler/paylasilanlar",
    permission: "contract.view",
  },
];

export function visibleContractSections(
  can: (permission: string) => boolean,
  sections: readonly ContractSection[] = CONTRACT_SECTIONS,
): ContractSection[] {
  return sections.filter((s) => s.permission === null || can(s.permission));
}
